import axios from '../Backend';

export const getModuleLastFilters = async (moduleId) => {
  try {
    if (!moduleId) return console.log('moduleId not provided');
    const res = await axios.get(`/api/v2/effective-crms/filters/${moduleId}`);
    return res.data?.data || [];
  } catch (err) {
    console.log(
      `getModuleLastFilters :: Error=${err.response?.data ? err.response.data.message : err.message}`
    );
    return [];
  }
};

export const saveModuleFilters = async (moduleId, filters = []) => {
  try {
    if (!moduleId) return console.log('moduleId not provided');
    await axios.post('/api/v2/effective-crms/filters', { moduleId, filters });
  } catch (err) {
    console.log(
      `saveModuleFilters :: Error=${err.response?.data ? err.response.data.message : err.message}`
    );
  }
};

export const clearModuleFilters = async (moduleId) => {
  try {
    if (!moduleId) return console.log('moduleId not provided');
    await axios.delete(`/api/v2/effective-crms/filters/${moduleId}`);
  } catch (err) {
    console.log(
      `clearModuleFilters :: Error=${err.response?.data ? err.response.data.message : err.message}`
    );
  }
};
